<template>
  <a-locale-provider :locale="zh_CN">
      <router-view />
  </a-locale-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import './lib/rem.js'
export default {
  name: 'app',
  data() {
    return {
      zh_CN,
    }
  }
}
</script>

<style>
html,body{
  background-color: #f0f2f5;
  width: 100vw;
  overflow-x: hidden;
}
#app {
  width: 100vw;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background-color: #f0f2f5;
  overflow-x: hidden;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
